import { Group, Input } from "@mantine/core";
import { IMaskInput } from "react-imask";

import { VDN_MASK } from "@/shared-types";

import classes from "./VdnInput.module.css";

export const VDN_MASK_PLACEHOLDER = "###-####";

interface VdnInputProps {
    value: string;
    onChange: (vdn: string) => void;
}

export function VdnInput({ value, onChange }: VdnInputProps) {
    return (
        <Group>
            <Input
                classNames={{ wrapper: classes.wrapper, input: classes.input }}
                component={IMaskInput}
                mask={VDN_MASK}
                value={value}
                onAccept={(value) => onChange(value)}
                placeholder={VDN_MASK_PLACEHOLDER}
                data-testid="vdn-input"
                styles={{
                    input: {
                        backgroundColor: "var(--mantine-color-dark-8)",
                    },
                }}
            />
        </Group>
    );
}
